"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoteCommandInvoker = void 0;
const RemoteInvocationInvoker_1 = require("../RemoteInvocationInvoker");
/**
 * RPC Command invoker
 */
class RemoteCommandInvoker extends RemoteInvocationInvoker_1.RemoteInvocationInvoker {
    /**
     * Execute method is a higher API method for invoking remote commands that will:
     * - Raise an exception on request or execution failures
     * - Raise an exception if the given command is not valid
     * - Return the ExecutionResult instead of the InvocationResult
     */
    invoke(cmdOrType, dataOrContext, context) {
        if (typeof cmdOrType === "function") {
            return super.invoke(cmdOrType, dataOrContext, context);
        }
        else {
            return super.invoke(cmdOrType, dataOrContext);
        }
    }
}
exports.RemoteCommandInvoker = RemoteCommandInvoker;
//# sourceMappingURL=RemoteCommandInvoker.js.map